import XAPPService from "app/Core/services/XAPPService";
import dayjs from "dayjs";
import Constante from "Constante.json";
import _ from "lodash";
export const GET_MENSAGENS = "[COMUNICADOR APP] GET MENSAGENS";
export const GET_MENSAGENS_NOTICE = "[COMUNICADOR APP] GET MENSAGENS VIA NOTICE";
export const GET_MENSAGENS_CENTRAL = "[COMUNICADOR APP] GET MENSAGENS DE CENTRAL";
export const GET_MENSAGEM_OPEN = "[COMUNICADOR APP] GET MENSAGEM OPEN";
export const SET_MENSAGEM_OPENED = "[COMUNICADOR APP] SET MENSAGEM OPENED";
export const REMOVE_MENSAGEM = "[COMUNICADOR APP] REMOVE MENSAGEM";
export const GET_LOCAIS = "[COMUNICADOR APP] GET LOCAIS";
export const GET_PERFIS = "[COMUNICADOR APP] GET PERFIS";
export const GET_DESTINATARIOS = "[COMUNICADOR APP] GET DESTINATARIOS";
export const GET_GRUPOSPERMISSAO = "[COMUNICADOR APP] GET GRUPOS PERMISSAO";
export const OPEN_COMUNICADOR_DIALOG = "[COMUNICADOR APP] OPEN COMUNICADOR DIALOG";
export const ADD_COMUNICADOR = "[COMUNICADOR APP] ADD COMUNICADOR";
export const COMUNICADOR_WARNING = "[COMUNICADOR APP] COMUNICADOR WARNING";
export const COMUNICADOR_INFO = "[COMUNICADOR APP] COMUNICADOR INFO";
export const COMUNICADOR_ERROR = "[COMUNICADOR APP] COMUNICADOR ERROR";
export const OPEN_COMUNICADOR_PRELOAD = "[COMUNICADOR APP] COMUNICADOR PRELOAD";

export function getInsumos(_AParams, _ALocaisAND = null) {
    return (dispatch, getState) => {
        dispatch(setPreload(true));
        let AContexto = { "token": getState().auth.user.data.settings.mensagemtokens[_AParams.empresa] };
        let AActions = [];
        let ALocaisAND = [{ "Campo": "checkescrita", "Valor": 0 }];
        if (!_.isNull(_ALocaisAND)) {
            ALocaisAND = _.concat(ALocaisAND, _ALocaisAND);
        }
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "locais", AActions, "spvwlocal", ["*"], "SELECIONAR", ALocaisAND, [], 1, AContexto);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "destinatarios", AActions, "spvwlocal", ["*"], "SELECIONAR", [{ "Campo": "checkescrita", "Valor": 1 }], [], 1, AContexto);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "perfis", AActions, "spvwperfilmensagem", ["*"], "SELECIONAR", [], [], 1, AContexto);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "grupospermissao", AActions, "spvwgrupopermissao", ["*"], "SELECIONAR", [], [], 1, AContexto);
        XAPPService.XappMensagemAction(AActions, _AParams, "SELACTION_INTERNA")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_LOCAIS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : null,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : null,
                    }),
                    dispatch({
                        type: GET_DESTINATARIOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : null,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : null,
                    }),
                    dispatch({
                        type: GET_PERFIS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].name : null,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].data : null,
                    }),
                    dispatch({
                        type: GET_GRUPOSPERMISSAO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[3].name : null,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[3].data : null,
                    }),
                    dispatch(setPreload(false))
                ])
            )
            .catch(error => {
                dispatch(setPreload(false));
                return dispatch({
                    type: COMUNICADOR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter, _APagina = 1) {

    return (dispatch, getState) => {
        const AOpen = getState().Comunicador.open ?? null;
        if (_AFilter.isCentral) {
            dispatch(setPreload(true));
        }
        let AContexto = { "token": getState().auth.user.data.settings.mensagemtokens[_AParams.empresa] };
        let AConditionsAND = [];
        let AConditionsOR = [];
        let AActions = [];

        if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
            AConditionsAND = AConditionsAND.concat(_AFilter.AND);
        }

        if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
            AConditionsOR = _AFilter.OR;
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "mensagens", AActions, _AFilter.procedure, ["*"], _AAction, AConditionsAND, AConditionsOR, _APagina, AContexto);

        if (!_.isNull(AOpen) && AOpen.tipo === 2) {
            let ACondition = [{ Campo: "mensagem.idmensagem", Operador: "=", Valor: AOpen.idmensagem }];
            AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "mensagem", AActions, "spvwmensagem", ["*"], _AAction, ACondition, AConditionsOR, 1, AContexto);
            AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "locais", AActions, "spvwlocal", ["*"], "SELECIONAR", [{ "Campo": "checkescrita", "Valor": 0 }], [], 1, AContexto);
        }

        XAPPService.XappMensagemAction(AActions, _AParams, "SELACTION_INTERNA")
            .then((response) => {
                dispatch({
                    type: _AFilter.isCentral ? GET_MENSAGENS_CENTRAL : GET_MENSAGENS,
                    Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                    payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                });
                if (!_.isNull(AOpen) && AOpen.tipo === 2 && JSON.parse(response.data).length > 1) {
                    Promise.all([
                        dispatch({
                            type: GET_MENSAGEM_OPEN,
                            Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                            payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                        }),
                        dispatch({
                            type: GET_LOCAIS,
                            Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].name : null,
                            payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].data : null,
                        })
                    ]);
                }
                dispatch(setPreload(false));
            })
            .catch(error => {
                dispatch(setPreload(false));
                return dispatch({
                    type: COMUNICADOR_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AAction, _AParams, _AFilter) {

    return (dispatch, getState) => {
        dispatch(setPreload(true));
        if (!_.isNull(getState().Comunicador.open) &&
            getState().Comunicador.open.idmensagem !== _.find(_AFilter.AND, { "Campo": "mensagem.idmensagem" }).Valor) {
            dispatch({
                type: GET_MENSAGEM_OPEN,
                payload: null,
            });
        }

        dispatch({
            type: SET_MENSAGEM_OPENED,
            idmensagem: _.find(_AFilter.AND, { "Campo": "mensagem.idmensagem" }).Valor,
        });

        let AContexto = { "token": getState().auth.user.data.settings.mensagemtokens[_AParams.empresa] };
        let AConditionsAND = [];
        let AConditionsOR = [];
        let AActions = [];

        if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
            AConditionsAND = AConditionsAND.concat(_AFilter.AND);
        }

        if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
            AConditionsOR = _AFilter.OR;
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "mensagens", AActions, "spvwmensagem", ["*"], _AAction, AConditionsAND, AConditionsOR, 1, AContexto);

        XAPPService.XappMensagemAction(AActions, _AParams, "SELACTION_INTERNA")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MENSAGEM_OPEN,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    }),
                    dispatch(setPreload(false))
                ])
            )
            .catch(error => {
                dispatch(setPreload(false));
                return dispatch({
                    type: COMUNICADOR_ERROR,
                    payload: error
                });
            });
    };
}

export function openDialog(_AValue = null) {
    return {
        type: OPEN_COMUNICADOR_DIALOG,
        payload: _AValue
    };
}

export function save(_AValue, _AParams, _AAction, _AFilter = null) {
    return (dispatch, getState) => {
        let ASettings = getState().auth.user.data.settings;
        let AContexto = { "token": ASettings.mensagemtokens[_AParams.empresa] };
        let AValue = Object.assign({}, _AValue);
        let AConditionsAND = [];
        let AConditionsOR = [];
        let AActions = [];
        if (_.isUndefined(_AValue.idmensagem) || _.isNull(_AValue.idmensagem)) {
            AValue.idmensagem = dayjs(new Date()).format("YYYYMMDDHHmmssSSS");
            _AFilter.AND.push({ "Campo": "mensagem.idmensagem", "Operador": "=", "Valor": AValue.idmensagem });
        }
        if (_.isUndefined(AValue.idremetente) || _.isNull(AValue.idremetente)) {
            AValue.idremetente = _AParams.idremetente;
        }
        if (_AParams.empresa === Constante.idxapp && !_.isNull(ASettings.sistemas[_AParams.idremetente].idpessoaxapp)) {
            AValue.idpessoaformulario = ASettings.sistemas[_AParams.idremetente].idpessoaxapp;
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "mensagem", _AAction, AValue, "", AConditionsAND, AConditionsOR, 1, null, AContexto);

        XAPPService.XappMensagemAction(AActions, _AParams, "DOACTION_INTERNA")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: COMUNICADOR_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_AFilter)) {
                            dispatch(list("SELECIONAR", _AParams, _AFilter, 1));
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: COMUNICADOR_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_AFilter)) {
                            if (_.isUndefined(_AValue.idmensagem) || _.isNull(_AValue.idmensagem)) {
                                dispatch(get("SELECIONAR", _AParams, _AFilter, 1));
                            }
                            else {
                                dispatch(list("SELECIONAR", _AParams, _AFilter, 1));
                            }
                        }
                    });
                }
            }

            ).catch(error => {
                return dispatch({
                    type: COMUNICADOR_ERROR,
                    payload: error
                });
            });
    };
}

export function saveCustom(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch, getState) => {
        let AContexto = { "token": getState().auth.user.data.settings.mensagemtokens[_AParams.empresa] };
        let AConditionsAND = [];
        let AConditionsOR = [];
        let AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, _AAction, _AAction, _AValue, "", AConditionsAND, AConditionsOR, 1, null, AContexto);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionmensagem", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: COMUNICADOR_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        dispatch(getInsumos(_AParams));
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: COMUNICADOR_INFO,
                            payload: response.info
                        })
                    ]).then(() => {
                        dispatch(getInsumos(_AParams));
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    });
                }
            }

            ).catch(error => {
                return dispatch({
                    type: COMUNICADOR_ERROR,
                    payload: error
                });
            });
    };
}

export function setNotices() {
    alert("Implementação pendente");
}

export function setPreload(_APreload = false) {
    return {
        type: OPEN_COMUNICADOR_PRELOAD,
        preload: _APreload
    };
}

export function addAppMessage(_AValue) {
    return {
        type: GET_MENSAGENS,
        payload: [{ ..._AValue, "mensagemSistema": true }]
    };
}

export function removeAppMessage(_AID) {
    return {
        type: REMOVE_MENSAGEM,
        id: _AID
    };
}

export function setOpenMessage(_AValue = null) {
    return {
        type: GET_MENSAGEM_OPEN,
        payload: !_.isNull(_AValue) ? [_AValue] : _AValue
    };
}

export function getUrlHelp(_APath = "") {
    return (dispatch, getState) => {
        XAPPService.getUrlHelp(_APath)
            .then(response => {
                dispatch({
                    type: GET_MENSAGEM_OPEN,
                    payload: [{ ...getState().Comunicador.open, url: response }]
                });
            })
            .catch(error => {
                console.error(error);
            });
    };
}